import { render } from "./CommentaryVerses.vue?vue&type=template&id=f4e8b384&ts=true"
import script from "./CommentaryVerses.vue?vue&type=script&lang=ts"
export * from "./CommentaryVerses.vue?vue&type=script&lang=ts"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__